import { useState } from "react";
import { Badge, Box, IconButton } from "@chakra-ui/react";
import { FiBell } from "react-icons/fi";
import { useAppSelector } from "newui/store/hooks";
import { selectCurrentUserId } from "newui/features/Auth/authSelectors";
import { useHasNotificationsConfiguration } from "hooks/featureFlags";
import { NotificationCentrePanel } from "./NotificationCentrePanel";
import { useUnreadCount } from "../hooks/useUnreadCount";
import { useNotificationCentreLive } from "../hooks/useNotificationCentreLive";

export const NotificationBell = () => {
	const hasFlag = useHasNotificationsConfiguration();
	const userId = useAppSelector(selectCurrentUserId);
	const [isOpen, setIsOpen] = useState(false);

	const unreadCountQuery = useUnreadCount(hasFlag);
	useNotificationCentreLive(userId ?? undefined, hasFlag);

	if (!hasFlag) {
		return null;
	}

	const unreadCount = unreadCountQuery.data ?? 0;

	return (
		<Box position="relative" data-testid="notification-bell">
			<IconButton
				aria-label="Notifications"
				icon={<FiBell />}
				variant="ghost"
				data-testid="notification-bell-button"
				onClick={() => setIsOpen(true)}
			/>
			{unreadCount > 0 ? (
				<Badge
					data-testid="notification-bell-badge"
					colorScheme="red"
					borderRadius="full"
					position="absolute"
					top="-1"
					right="-1"
					fontSize="xs"
					minW="5"
					textAlign="center"
				>
					{unreadCount}
				</Badge>
			) : null}
			<NotificationCentrePanel isOpen={isOpen} onClose={() => setIsOpen(false)} />
		</Box>
	);
};
